export const logsHorasInitialState = {
  logs: [],
};
